// src/services/api.js
import axios from "axios";

const api = axios.create({
  baseURL: "https://apiatschool.roboticminds.ec",

});


api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const fetchDatos = async (collegeId) => {
  try {
    // Enviamos tanto collegeId como categoryId por si el backend espera uno u otro
    const response = await api.get("/data/datos", {
      params: {
        collegeId,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error al obtener los datos:", error);
    throw error;
  }
};

export const asignarColegioProfesor = async ({ username, categoryId }) => {
  try {
    const response = await api.patch("/update/data", {
      username,
      categoryId: parseInt(categoryId)
    });
    return response.data;
  } catch (error) {
    console.error("Error al asignar colegio al profesor:", error);
    throw error;
  }
};

export const actualizarUsuarioEva = async ({ username, password, rolEstadistica, categoryId }) => {
  try {
    const response = await api.patch("/update/data", {
      username,
      password,
      rolEstadistica,
      categoryId,
    });
    return response.data;
  } catch (error) {
    console.error("Error al actualizar usuario EVA:", error);
    throw error;
  }
};


export default api;
